import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './SmallRemoveButton.scss';
import classNames from 'classnames';

export default class SmallRemoveButton extends Component {
    static propTypes = {
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired
    };

    render() {
        const {className, onClick} = this.props;

        const buttonClassName = classNames(styles.removeButton, className);

        return (
            <div className={buttonClassName} onClick={onClick}></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/SmallRemoveButton.jsx